<template>
  <div class="page-wrapper thoivu-wrapper" :class="{'is-mobile': isMobile}">
    <div class="content container-fluid">

      <!-- Header -->
      <div class="page-header header-sticky">
        <div class="row align-items-center">
          <div class="col-12 d-flex align-items-center justify-content-between flex-wrap">
            <div class="mb-2">
              <h3 class="page-title mb-1">
                Quản lý chấm công <span class="badge badge-info">THỜI VỤ</span>
              </h3>
              <ul class="breadcrumb mb-0 small">
                <li class="breadcrumb-item"><a href="/">Dashboard</a></li>
                <li class="breadcrumb-item active">Attendance (Thời vụ)</li>
              </ul>
            </div>

            <!-- Controls -->
            <div class="d-flex align-items-center flex-wrap mb-2">
              <div class="btn-group mr-2 mb-2" role="group" aria-label="View mode">
                <button class="btn btn-outline-primary btn-sm" :class="{active:viewMode==='icon'}" @click="viewMode='icon'">
                  <i class="fa fa-th mr-1"></i> Icon
                </button>
                <button class="btn btn-outline-primary btn-sm" :class="{active:viewMode==='cong'}" @click="viewMode='cong'">
                  <i class="fa fa-list-ol mr-1"></i> Số công
                </button>
              </div>

              <div class="input-group input-group-sm mr-2 mb-2" style="width: 150px;">
                <div class="input-group-prepend">
                  <button class="btn btn-outline-secondary" @click="prevMonth" :disabled="loading" title="Tháng trước">‹</button>
                </div>
                <input type="month" class="form-control" v-model="filter.month" @change="fetchAll">
                <div class="input-group-append">
                  <button class="btn btn-outline-secondary" @click="nextMonth" :disabled="loading" title="Tháng sau">›</button>
                </div>
              </div>

              <button class="btn btn-success btn-sm mr-2 mb-2" @click="fetchAll" :disabled="loading">
                <i class="fa fa-refresh mr-1"></i> Tải
              </button>

              <div class="btn-group mb-2">
                <button class="btn btn-outline-info btn-sm" :disabled="loading || !matrix" @click="exportExcel('include')">
                  <i class="fa fa-file-excel-o mr-1"></i> Xuất (bao gồm QT)
                </button>
                <button class="btn btn-outline-warning btn-sm" :disabled="loading || !matrix" @click="exportExcel('exclude')">
                  <i class="fa fa-file-excel-o mr-1"></i> Xuất (loại QT)
                </button>
              </div>
              <span class="small text-muted ml-2 mb-2" v-if="selectedCount>0">
                Đã chọn: <b>{{ selectedCount }}</b> LĐ
              </span>
            </div>
          </div>
        </div>

        <!-- Filters -->
        <div class="row filter-row mt-2">
          <div class="col-12 col-sm-6 col-md-4">
            <div class="form-group form-focus">
              <input type="text" class="form-control floating" v-model.trim="filter.keyword" placeholder="Tên/SĐT" @keyup.enter="fetchAll">
              <label class="focus-label">Tên/SĐT</label>
            </div>
          </div>
        </div>
      </div>

      <!-- Matrix -->
      <div v-if="matrix" class="mt-2">
        <div class="table-sticky-wrap" :style="tableVars">
          <div class="table-scroll-shadow left" v-show="scrollMeta.showLeft"></div>
          <div class="table-scroll-shadow right" v-show="scrollMeta.showRight"></div>

          <div ref="tableWrap" class="table-responsive table-scroll-x" @scroll="onTableScroll">
            <table class="table table-striped custom-table table-nowrap mb-0">
              <thead>
                <tr>
                  <!-- Select all -->
                  <th class="sticky-col col-select text-center">
                    <input type="checkbox" :checked="isAllVisibleSelected" @change="toggleSelectAll($event)">
                  </th>

                  <th class="sticky-col col-name">Lao động</th>

                  <th v-for="hd in headerDays" :key="'h'+hd.day"
                      class="day-col head-day text-center" :class="{'sun-head': hd.isSun}">
                    <div class="head-cell">
                      <span class="dow">{{ hd.dowShort }}</span>
                      <span class="daynum">{{ hd.day }}</span>
                    </div>
                  </th>

                  <th class="text-right col-total">Tổng công</th>
                  <th class="text-right col-ot">Tổng TC (giờ)</th>
                  <th class="sticky-end col-actions text-center">QT</th>
                </tr>
              </thead>

              <tbody>
                <tr v-for="(row,idx) in matrix.rows" :key="row.ldId">
                  <td class="sticky-col col-select text-center align-middle">
                    <input type="checkbox" :checked="selectedIds.has(row.ldId)" @change="toggleSelect(row.ldId,$event)">
                  </td>

                  <td class="sticky-col col-name align-middle">
                    <div class="d-flex align-items-center">
                      <div class="d-inline-flex flex-column">
                        <span class="font-weight-bold name-ellipsis">{{ row.hoTen }}</span>
                        <small class="text-muted text-monospace">#{{ row.ldId }}</small>
                      </div>
                    </div>
                  </td>

                  <td v-for="cell in row.daily"
                      :key="row.ldId + '-' + cell.day"
                      class="day-col day-cell text-center"
                      :class="[{ 'sunday-cell': isSunday(cell.day) }, {'locked-cell': cell.locked}]"
                      :title="tooltipCell(row, cell)"
                      @click="onClickCell(row, cell)">
                    <!-- 3 BUỔI -->
                    <div class="triple-slot" v-if="viewMode==='icon'">
                      <span class="triple-line">
                        <small class="label">S</small>
                        <i :class="cell.sang ? 'fa fa-check text-success' : 'fa fa-times text-danger'"></i>
                      </span>
                      <span class="triple-line">
                        <small class="label">C</small>
                        <i :class="cell.chieu ? 'fa fa-check text-success' : 'fa fa-times text-danger'"></i>
                      </span>
                      <span class="triple-line">
                        <small class="label">TC</small>
                        <span class="badge badge-light"
                              :class="{'badge-ot-on': (cell.otThuong10||0)+(cell.otCN10||0)>0}">
                          {{ dToStr((cell.otThuong10||0)+(cell.otCN10||0)) }}h
                        </span>
                      </span>
                      <i v-if="cell.locked" class="fa fa-lock text-muted lock-mark" aria-hidden="true"></i>
                    </div>

                    <div v-else class="triple-numeric">
                      <div class="cong-box" :class="congClass(cell.sang, false)">S: {{ (cell.sang?0.5:0).toFixed(2) }}</div>
                      <div class="cong-box mt-1" :class="congClass(false, cell.chieu)">C: {{ (cell.chieu?0.5:0).toFixed(2) }}</div>
                      <div class="ot-box mt-1">TC: {{ dToStr((cell.otThuong10||0)+(cell.otCN10||0)) }}h</div>
                      <i v-if="cell.locked" class="fa fa-lock text-muted lock-mark" aria-hidden="true"></i>
                    </div>
                  </td>

                  <td class="text-right font-weight-bold col-total align-middle">
                    {{ sumRowCong(row).toFixed(2) }}
                  </td>
                  <td class="text-right font-weight-bold col-ot align-middle">
                    {{ sumRowOT(row).toFixed(1) }}
                  </td>
                  <td class="sticky-end col-actions align-middle text-center">
                    <div class="btn-group btn-group-sm">
                      <button class="btn btn-outline-primary" @click="openQuyetToan(row)" title="Quyết toán giữa kỳ">QT</button>
                      <button class="btn btn-outline-dark" @click="openLichSu(row)" title="Lịch sử quyết toán">
                        <i class="fa fa-history"></i>
                      </button>
                    </div>
                  </td>
                </tr>

                <tr v-if="matrix.rows.length === 0">
                  <td :colspan="(matrix.daysInMonth + 6)" class="text-center text-muted">Không có dữ liệu</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div class="mt-2 small text-muted d-flex flex-wrap">
          <span class="mr-3">
            <b>3 buổi</b>: Sáng, Chiều (mỗi buổi = 0.5 công), <b>TC</b> = số giờ (BigDecimal, chính xác 0.1h).
          </span>
          <span class="mr-3">
            <i class="fa fa-lock text-muted"></i> ô đã <b>khóa</b> vì nằm trong khoảng đã quyết toán.
          </span>
        </div>
      </div>

      <div v-else-if="!loading" class="text-muted">Chưa có dữ liệu</div>
    </div>

    <!-- Modal NGÀY -->
    <div class="modal custom-modal fade show" v-if="dayModal.open" style="display:block;" role="dialog" aria-modal="true">
      <div class="modal-dialog" :class="isMobile ? 'modal-fullscreen' : 'modal-dialog-centered modal-dialog-scrollable'" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">
              {{ dayModal.row?.hoTen }} — {{ formatDateHuman(dayModal.date) }}
              <span v-if="dayModal.locked" class="badge badge-light ml-2"><i class="fa fa-lock"></i> ĐÃ QUYẾT TOÁN</span>
            </h5>
            <button type="button" class="close" @click="closeDayModal"><span>&times;</span></button>
          </div>

          <div class="modal-body">
            <div v-if="dayModal.locked" class="alert alert-warning">
              Ngày này thuộc <b>khoảng đã quyết toán</b>, không thể chỉnh sửa. Muốn sửa, hãy hủy quyết toán tương ứng trong <b>Lịch sử quyết toán</b>.
            </div>

            <div class="form-row" :class="{'opacity-60': dayModal.locked}">
              <div class="col-12 col-sm-4">
                <div class="custom-control custom-checkbox mb-2">
                  <input type="checkbox" class="custom-control-input" id="chkSang" v-model="dayModal.state.sang" :disabled="dayModal.locked">
                  <label class="custom-control-label" for="chkSang">Buổi Sáng (0.5)</label>
                </div>
              </div>
              <div class="col-12 col-sm-4">
                <div class="custom-control custom-checkbox mb-2">
                  <input type="checkbox" class="custom-control-input" id="chkChieu" v-model="dayModal.state.chieu" :disabled="dayModal.locked">
                  <label class="custom-control-label" for="chkChieu">Buổi Chiều (0.5)</label>
                </div>
              </div>
              <div class="col-12 col-sm-4">
                <div class="form-group mb-2">
                  <label class="mb-1">Buổi TC (giờ)</label>
                  <div class="input-group">
                    <input type="text" inputmode="decimal" class="form-control"
                           v-model.trim="dayModal.state.otTotalStr" placeholder="vd: 1.5" :disabled="dayModal.locked">
                    <div class="input-group-append"><span class="input-group-text">h</span></div>
                  </div>
                  <small class="text-muted">Tự tách CN nếu là Chủ nhật</small>
                </div>
              </div>
            </div>

            <div class="text-right mt-2">
              <button class="btn btn-warning" @click="saveDay" :disabled="savingAdjust || dayModal.locked">
                <i class="fa fa-save mr-1"></i>Lưu
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal QUYẾT TOÁN -->
    <div class="modal custom-modal fade show" v-if="qtModal.open" style="display:block;" role="dialog" aria-modal="true">
      <div class="modal-dialog" :class="isMobile ? 'modal-fullscreen' : 'modal-dialog-centered modal-lg'" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">
              Quyết toán giữa kỳ — <span class="text-primary">{{ qtModal.row?.hoTen }}</span>
            </h5>
            <button type="button" class="close" @click="qtModal.open=false"><span>&times;</span></button>
          </div>

          <div class="modal-body">
            <div class="form-row">
              <div class="form-group col-12 col-sm-4">
                <label>Từ ngày</label>
                <input type="date" class="form-control" v-model="qtModal.from" @change="loadPreview">
              </div>
              <div class="form-group col-12 col-sm-4">
                <label>Đến ngày</label>
                <input type="date" class="form-control" v-model="qtModal.to" @change="loadPreview">
              </div>
              <div class="form-group col-12 col-sm-4">
                <label>Ghi chú</label>
                <input type="text" class="form-control" v-model.trim="qtModal.ghiChu" placeholder="vd: QT tuần 1">
              </div>
            </div>

            <div class="alert" :class="qtModal.overlapWarn ? 'alert-warning' : 'alert-info'">
              <div v-if="qtModal.overlapWarn">
                <i class="fa fa-exclamation-triangle mr-1"></i>
                Khoảng này <b>trùng</b> với quyết toán cũ. Các ngày bị trùng sẽ bị <b>loại</b> khỏi quyết toán mới.
              </div>
              <div v-else>
                <i class="fa fa-info-circle mr-1"></i>
                Chọn khoảng ngày để quyết toán giữa kỳ. FE xem trước tiền bằng <code>/api/thoivu/cham-cong/tinh-luong/{id}</code>.
              </div>
            </div>

            <div class="card">
              <div class="card-body">
                <h5 class="card-title mb-2">Tổng tiền xem trước</h5>
                <div class="row">
                  <div class="col-6 col-md-3">
                    <div class="mini-kpi"><div class="kpi-label">Tiền HC</div><div class="kpi-value">{{ money(qtModal.preview.tienHanhChinh) }}</div></div>
                  </div>
                  <div class="col-6 col-md-3">
                    <div class="mini-kpi"><div class="kpi-label">Tiền CN</div><div class="kpi-value">{{ money(qtModal.preview.tienChuNhat) }}</div></div>
                  </div>
                  <div class="col-6 col-md-3">
                    <div class="mini-kpi"><div class="kpi-label">Tiền TC</div><div class="kpi-value">{{ money(qtModal.preview.tienTangCa) }}</div></div>
                  </div>
                  <div class="col-6 col-md-3">
                    <div class="mini-kpi"><div class="kpi-label">Tiền TC CN</div><div class="kpi-value">{{ money(qtModal.preview.tienTangCaCN) }}</div></div>
                  </div>
                </div>
                <div class="mt-2 text-right">
                  <b>TỔNG: {{ money(qtModal.preview.tongTien) }}</b>
                </div>
              </div>
            </div>

            <div class="small text-muted mt-2">
              * Ngày đã quyết toán trước đó sẽ bị khóa trên lưới. Hủy quyết toán sẽ mở khóa lại.
            </div>
          </div>

          <div class="modal-footer">
            <button class="btn btn-light" @click="qtModal.open=false">Đóng</button>
            <button class="btn btn-primary" :disabled="creatingQT || !qtModal.from || !qtModal.to" @click="createQuyetToan">
              <i class="fa fa-check mr-1"></i>Tạo quyết toán
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal LỊCH SỬ QUYẾT TOÁN -->
    <div class="modal custom-modal fade show" v-if="lsModal.open" style="display:block;" role="dialog" aria-modal="true">
      <div class="modal-dialog" :class="isMobile ? 'modal-fullscreen' : 'modal-dialog-centered modal-xl'" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">
              Lịch sử quyết toán — <span class="text-primary">{{ lsModal.row?.hoTen }}</span>
            </h5>
            <button type="button" class="close" @click="lsModal.open=false"><span>&times;</span></button>
          </div>

          <div class="modal-body">
            <div class="table-responsive">
              <table class="table table-striped table-hover mb-0">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Khoảng</th>
                    <th class="text-right">HC</th>
                    <th class="text-right">CN</th>
                    <th class="text-right">TC</th>
                    <th class="text-right">TC CN</th>
                    <th class="text-right">TỔNG</th>
                    <th>Trạng thái</th>
                    <th>Người tạo</th>
                    <th>Ngày tạo</th>
                    <th class="text-right">Thao tác</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(q,i) in lsModal.list" :key="q.id">
                    <td>{{ i+1 }}</td>
                    <td>{{ q.from }} → {{ q.to }}</td>
                    <td class="text-right">{{ money(q.tienHanhChinh) }}</td>
                    <td class="text-right">{{ money(q.tienChuNhat) }}</td>
                    <td class="text-right">{{ money(q.tienTangCa) }}</td>
                    <td class="text-right">{{ money(q.tienTangCaCN) }}</td>
                    <td class="text-right font-weight-bold">{{ money(q.tongTien) }}</td>
                    <td>
                      <span :class="q.status==='COMPLETED' ? 'badge badge-success' : 'badge badge-secondary'">
                        {{ q.status==='COMPLETED' ? 'Đã quyết toán' : (q.status==='CANCELED'?'Đã hủy':'—') }}
                      </span>
                    </td>
                    <td>{{ q.createdByName || ('#'+(q.createdBy||'—')) }}</td>
                    <td>{{ fmtDT(q.createdAt) }}</td>
                    <td class="text-right">
                      <div class="btn-group btn-group-sm">
                        <button class="btn btn-outline-dark" @click="openNhatKy(q)"><i class="fa fa-list-ul"></i> Nhật ký</button>
                        <button v-if="q.status==='COMPLETED'" class="btn btn-outline-danger" @click="cancelQuyetToan(q)">
                          Hủy
                        </button>
                      </div>
                    </td>
                  </tr>
                  <tr v-if="lsModal.list.length===0">
                    <td colspan="11" class="text-center text-muted">Chưa có quyết toán</td>
                  </tr>
                </tbody>
              </table>
            </div>

            <!-- Nhật ký thao tác -->
            <div v-if="lsModal.logsOpen" class="card mt-3">
              <div class="card-body">
                <h6 class="mb-2">Nhật ký thao tác (QT #{{ lsModal.logsFor?.id }})</h6>
                <ul class="list-unstyled mb-0 small">
                  <li v-for="(lg,idx) in lsModal.logs" :key="idx">
                    <span class="text-monospace">{{ fmtDT(lg.at) }}</span> —
                    <b>{{ lg.actorName || ('#'+(lg.actor||'—')) }}</b>:
                    {{ lg.action }} <span v-if="lg.note" class="text-muted">({{ lg.note }})</span>
                  </li>
                  <li v-if="lsModal.logs.length===0" class="text-muted">Không có dữ liệu — BE chưa trả nhật ký, đã hiển thị meta thay thế.</li>
                </ul>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>

    <!-- Mobile month FAB -->
    <div v-if="isMobile" class="mobile-fab">
      <button class="btn btn-light btn-sm shadow" @click="prevMonth" :disabled="loading" title="Tháng trước">‹</button>
      <div class="mx-2 small font-weight-bold">{{ ymLabel }}</div>
      <button class="btn btn-light btn-sm shadow" @click="nextMonth" :disabled="loading" title="Tháng sau">›</button>
      <button class="btn btn-success btn-sm shadow ml-2" @click="exportExcel('include')" :disabled="loading || !matrix">
        <i class="fa fa-file-excel-o"></i>
      </button>
    </div>
  </div>
</template>

<script>
import api from "../api";
import Swal from "sweetalert2";
import XLSX from "xlsx-js-style";

export default {
  name: "QuanLyChamCongThoiVu",
  data() {
    const now = new Date();
    const ym = `${now.getFullYear()}-${String(now.getMonth()+1).padStart(2,'0')}`;
    return {
      loading: false,
      matrix: null,
      viewMode: "icon",
      filter: { keyword: "", month: ym },

      // chọn xuất
      selectedIds: new Set(),

      // modal ngày
      dayModal: { open: false, row: null, date: null, state: { sang:false, chieu:false, otTotalStr:"" }, locked: false },
      savingAdjust: false,

      // Quyết toán
      qtModal: {
        open: false, row: null, from: "", to: "", ghiChu: "",
        preview: { tienHanhChinh:0, tienChuNhat:0, tienTangCa:0, tienTangCaCN:0, tongTien:0 },
        overlapWarn: false
      },
      creatingQT: false,

      // Lịch sử QT
      lsModal: { open:false, row:null, list:[], logsOpen:false, logs:[], logsFor:null },

      // responsive
      isMobile: false,
      scrollMeta: { showLeft:false, showRight:false },

      // sticky sizes (CSS variables)
      sizes: { select: 44, name: 200, total: 92, ot: 110, day: 36, dayMobile: 34 }
    };
  },
  computed: {
    ymLabel() {
      if (!this.filter.month) return "";
      const [y,m] = this.filter.month.split("-").map(Number);
      return `Tháng ${m}/${y}`;
    },
    headerDays() {
      const arr = [];
      if (!this.matrix) return arr;
      const [y,m] = this.filter.month.split("-").map(Number);
      for (let d=1; d<=this.matrix.daysInMonth; d++) {
        const dt = new Date(y, m-1, d);
        arr.push({ day:d, dowShort: dt.toLocaleDateString("vi-VN",{weekday:"short"}), isSun: dt.getDay()===0 });
      }
      return arr;
    },
    tableVars() {
      const select = this.sizes.select;
      const name = this.isMobile ? 160 : this.sizes.name;
      const dayW = this.isMobile ? this.sizes.dayMobile : this.sizes.day;
      const total = this.sizes.total;
      const ot = this.sizes.ot;
      return {
        '--w-select': `${select}px`,
        '--w-name': `${name}px`,
        '--w-day': `${dayW}px`,
        '--w-total': `${total}px`,
        '--w-ot': `${ot}px`,
        '--left-name': `${select}px`
      };
    },
    selectedCount(){ return this.selectedIds.size; },
    isAllVisibleSelected(){
      if (!this.matrix) return false;
      return this.matrix.rows.every(r => this.selectedIds.has(r.ldId));
    }
  },
  mounted() {
    this.onResize();
    window.addEventListener('resize', this.onResize, { passive:true });
    this.fetchAll();
    this.$nextTick(this.onTableScroll);
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.onResize);
  },
  methods: {
    // ===== Decimal helpers (0.1h precision) =====
    dParse(val) {
      if (val === null || val === undefined) return 0;
      const s = String(val).replace(',', '.').trim();
      if (s === '' || isNaN(Number(s))) return 0;
      return Math.round(parseFloat(s) * 10);
    },
    dAdd(a, b) { return a + b; },
    dToStr(tenth) { const n=(tenth/10); const s=n.toFixed(1); return s.endsWith('.0')?s.slice(0,-2):s; },
    dToNumber(tenth) { return +(tenth/10).toFixed(1); },

    money(v){ const n=Number(v||0); return n.toLocaleString("vi-VN"); },

    // ===== chọn xuất =====
    toggleSelect(id, ev){
      if (ev.target.checked) this.selectedIds.add(id); else this.selectedIds.delete(id);
      // force reactivity
      this.selectedIds = new Set(this.selectedIds);
    },
    toggleSelectAll(ev){
      if (!this.matrix) return;
      if (ev.target.checked) this.matrix.rows.forEach(r=> this.selectedIds.add(r.ldId));
      else this.selectedIds.clear();
      this.selectedIds = new Set(this.selectedIds);
    },
    getExportRows(){
      if (!this.matrix) return [];
      if (this.selectedIds.size===0) return this.matrix.rows;
      return this.matrix.rows.filter(r => this.selectedIds.has(r.ldId));
    },

    // ===== Load tháng =====
    async fetchAll(){
      this.loading = true;
      try{
        this.selectedIds.clear();

        const [y,m] = this.filter.month.split("-").map(Number);
        const from = `${y}-${String(m).padStart(2,'0')}-01`;
        const dim = new Date(y, m, 0).getDate();
        const to = `${y}-${String(m).padStart(2,'0')}-${String(dim).padStart(2,'0')}`;

        // danh sách LĐ thời vụ (đang làm)
        const rsLd = await api.get("/api/thoivu/lao-dong", {
          params: { keyword: this.filter.keyword||"", status:1, page:0, size:500 }
        });
        const list = rsLd?.data?.data?.content || [];

        const rows = list.map(ld => ({
          ldId: ld.id, hoTen: ld.hoTen,
          daily: Array.from({length: dim}, (_,i)=>({ day:i+1, sang:false, chieu:false, otThuong10:0, otCN10:0, locked:false, qtId:null }))
        }));

        // fill công & tăng ca
        const batch = 6;
        for (let i=0;i<rows.length;i+=batch){
          await Promise.all(rows.slice(i,i+batch).map(async r=>{
            const p = { idThoivuLd: r.ldId, from, to };
            const [resNgay, resOT] = await Promise.all([
              api.get("/api/thoivu/cham-cong/ngay/by-lao-dong",{params:p}),
              api.get("/api/thoivu/cham-cong/tang-ca/by-lao-dong",{params:p})
            ]);

            const mapNgay = new Map();
            (resNgay?.data?.data || []).forEach(it=>{
              const day = new Date(it.ngay).getDate();
              mapNgay.set(day, {sang:!!it.sang, chieu:!!it.chieu});
            });
            r.daily.forEach(c=>{ const x = mapNgay.get(c.day); if (x){ c.sang = x.sang; c.chieu = x.chieu; } });

            const agg = {};
            (resOT?.data?.data || []).forEach(it=>{
              const day = new Date(it.ngay).getDate();
              if(!agg[day]) agg[day] = { thuong10:0, cn10:0 };
              const val10 = this.dParse(it.soGio);
              if (it.isChuNhat) agg[day].cn10 = this.dAdd(agg[day].cn10, val10);
              else agg[day].thuong10 = this.dAdd(agg[day].thuong10, val10);
            });
            r.daily.forEach(c=>{
              if (agg[c.day]) { c.otThuong10 = agg[c.day].thuong10; c.otCN10 = agg[c.day].cn10; }
            });
          }));
        }

        this.matrix = { daysInMonth: dim, rows };

        // đánh dấu khóa theo quyết toán
        await this.applyLocksForMonth(from, to);

        this.$nextTick(this.onTableScroll);
      }catch(e){
        console.error(e);
        this.matrix=null;
        this.alertUser("Không tải dữ liệu", "error");
      }finally{ this.loading=false; }
    },

    // ===== Locks (quyết toán) =====
    async applyLocksForMonth(from, to){
      if (!this.matrix) return;
      const batch = 6;
      for (let i=0;i<this.matrix.rows.length;i+=batch){
        await Promise.all(this.matrix.rows.slice(i,i+batch).map(async r=>{
          try{
            const { data } = await api.get(`/api/thoivu/quyet-toan/by-lao-dong/${r.ldId}`, { params:{ from, to }});
            const list = data?.data || [];
            this.markRowLocks(r, list);
          }catch(e){ /* ignore */ }
        }));
      }
    },
    markRowLocks(row, qtList){
      if (!qtList?.length) return;
      const [y,m] = this.filter.month.split("-").map(Number);
      const monthStart = new Date(`${y}-${String(m).padStart(2,'0')}-01T00:00:00`);
      const monthEnd   = new Date(`${y}-${String(m).padStart(2,'0')}-${String(this.matrix.daysInMonth).padStart(2,'0')}T23:59:59`);

      qtList.filter(q => q.status === 'COMPLETED').forEach(q=>{
        const f = new Date(`${q.from}T00:00:00`);
        const t = new Date(`${q.to}T23:59:59`);
        const s = f > monthStart ? f : monthStart;
        const e = t < monthEnd   ? t : monthEnd;

        for (let d=1; d<=this.matrix.daysInMonth; d++){
          const cd = new Date(y, m-1, d);
          if (cd >= s && cd <= e){
            const cell = row.daily.find(c=>c.day===d);
            if (cell){ cell.locked = true; cell.qtId = q.id; }
          }
        }
      });
    },

    // ===== Tổng trong UI =====
    sumRowCong(row){
      return (row.daily||[]).reduce((s,c)=> s + (c.sang?0.5:0) + (c.chieu?0.5:0), 0);
    },
    sumRowOT(row){
      const total10 = (row.daily||[]).reduce((s,c)=> this.dAdd(s,(c.otThuong10||0)+(c.otCN10||0)), 0);
      return this.dToNumber(total10);
    },

    // ===== Cell utils =====
    isSunday(day){ const [y,m]=this.filter.month.split("-").map(Number); return new Date(y,m-1,day).getDay()===0; },
    congClass(sang, chieu){ const v=(sang?0.5:0)+(chieu?0.5:0); if(v>=0.5) return "cong-mid"; return "cong-zero"; },
    tooltipCell(row,cell){
      const ot = this.dToStr((cell.otThuong10||0)+(cell.otCN10||0));
      const [y,m]=this.filter.month.split("-").map(Number);
      const dt=new Date(y,m-1,cell.day);
      const dstr=dt.toLocaleDateString("vi-VN",{weekday:"short", day:"2-digit", month:"2-digit"});
      const lock = cell.locked ? "\n(ĐÃ QUYẾT TOÁN — khóa)" : "";
      return `${row.hoTen} — ${dstr}\nS: ${cell.sang?'0.5':'0.0'} | C: ${cell.chieu?'0.5':'0.0'} | TC: ${ot}h${lock}`;
    },

    onClickCell(row,cell){
      const [y,m]=this.filter.month.split("-").map(Number);
      const date=`${y}-${String(m).padStart(2,'0')}-${String(cell.day).padStart(2,'0')}`;
      const total10 = (cell.otThuong10||0) + (cell.otCN10||0);
      this.dayModal = {
        open:true, row, date,
        state:{ sang:!!cell.sang, chieu:!!cell.chieu, otTotalStr: this.dToStr(total10) },
        locked: !!cell.locked
      };
    },

    // ===== Modal ngày save =====
    async saveDay(){
      if (!this.dayModal.open) return;
      if (this.dayModal.locked){
        this.alertUser("Ngày này đã quyết toán — hãy hủy quyết toán tương ứng nếu cần chỉnh sửa","warning");
        return;
      }
      this.savingAdjust=true;
      try{
        const { row, date, state } = this.dayModal;

        await api.post("/api/thoivu/cham-cong/ngay", {
          idThoivuLd: row.ldId, ngay: date, sang: !!state.sang, chieu: !!state.chieu, ghiChu: null
        });

        const isCn        = (new Date(date).getDay()===0);
        const total10     = this.dParse(state.otTotalStr);
        const soThuong10  = isCn ? 0 : total10;
        const soCn10      = isCn ? total10 : 0;

        const soGioThuong = this.dToStr(soThuong10);
        const soGioCN     = this.dToStr(soCn10);

        await api.put("/api/thoivu/cham-cong/tang-ca/upsert-day", null, {
          params: { idThoivuLd: row.ldId, ngay: date, soGioThuong, soGioCN, ghiChu: "Buổi TC" }
        });

        // patch UI
        const dayNum = Number(date.split('-')[2]);
        const cell = row.daily.find(c=>c.day===dayNum);
        if (cell){
          cell.sang = !!state.sang; cell.chieu = !!state.chieu;
          cell.otThuong10 = soGioThuong ? this.dParse(soGioThuong) : 0;
          cell.otCN10     = soGioCN ? this.dParse(soGioCN) : 0;
        }

        this.toastOk("Đã lưu");
        this.closeDayModal();
      }catch(e){
        console.error(e);
        this.alertUser("Lưu lỗi", "error");
      }finally{ this.savingAdjust=false; }
    },
    closeDayModal(){ this.dayModal.open=false; },

    // ===== Quyết toán giữa kỳ =====
    openQuyetToan(row){
      const today = new Date();
      const [y,m] = this.filter.month.split("-").map(Number);
      const from = `${y}-${String(m).padStart(2,'0')}-01`;
      const to = `${y}-${String(m).padStart(2,'0')}-${String(Math.min(new Date(y,m,0).getDate(), today.getDate())).padStart(2,'0')}`;

      this.qtModal = {
        open:true, row, from, to, ghiChu:"",
        preview:{tienHanhChinh:0,tienChuNhat:0,tienTangCa:0,tienTangCaCN:0,tongTien:0},
        overlapWarn:false
      };
      this.loadPreview();
    },
    async loadPreview(){
      if (!this.qtModal.open || !this.qtModal.from || !this.qtModal.to) return;
      try{
        const id = this.qtModal.row.ldId;
        const { data } = await api.get(`/api/thoivu/cham-cong/tinh-luong/${id}`, {
          params:{ from: this.qtModal.from, to: this.qtModal.to }
        });
        const p = data?.data || {};
        this.qtModal.preview = {
          tienHanhChinh: Number(p.tienHanhChinh||0),
          tienChuNhat:   Number(p.tienChuNhat||0),
          tienTangCa:    Number(p.tienTangCa||0),
          tienTangCaCN:  Number(p.tienTangCaCN||0),
          tongTien:      Number(p.tongTien||0)
        };

        // kiểm tra overlap để cảnh báo
        const rs = await api.get(`/api/thoivu/quyet-toan/by-lao-dong/${id}`, { params:{ from: this.qtModal.from, to: this.qtModal.to }});
        const list = rs?.data?.data || [];
        this.qtModal.overlapWarn = (list || []).some(q => q.status==='COMPLETED');
      }catch(e){
        console.error(e);
        this.qtModal.preview = {tienHanhChinh:0,tienChuNhat:0,tienTangCa:0,tienTangCaCN:0,tongTien:0};
      }
    },
    async createQuyetToan(){
      if (!this.qtModal.open) return;
      this.creatingQT = true;
      try{
        const body = {
          idThoivuLd: this.qtModal.row.ldId,
          from: this.qtModal.from,
          to: this.qtModal.to,
          ghiChu: this.qtModal.ghiChu || null
        };
        const { data } = await api.post("/api/thoivu/quyet-toan", body);
        const created = data?.data;

        // đánh dấu lock ngay trên UI
        this.markRowLocks(this.qtModal.row, [{...created, status:'COMPLETED'}]);

        this.toastOk("Đã tạo quyết toán");
        this.qtModal.open=false;
      }catch(e){
        console.error(e);
        this.alertUser(e?.response?.data?.message || "Tạo quyết toán lỗi", "error");
      }finally{
        this.creatingQT=false;
      }
    },

    // ===== Lịch sử QT =====
    async openLichSu(row){
      this.lsModal = { open:true, row, list:[], logsOpen:false, logs:[], logsFor:null };
      try{
        // lấy lịch sử toàn tháng đang xem (tiện tra cứu)
        const [y,m] = this.filter.month.split("-").map(Number);
        const from = `${y}-${String(m).padStart(2,'0')}-01`;
        const to = `${y}-${String(m).padStart(2,'0')}-${String(new Date(y,m,0).getDate()).padStart(2,'0')}`;
        const { data } = await api.get(`/api/thoivu/quyet-toan/by-lao-dong/${row.ldId}`, { params:{ from, to }});
        this.lsModal.list = data?.data || [];
      }catch(e){
        console.error(e); this.lsModal.list=[];
      }
    },
    async openNhatKy(q){
      this.lsModal.logsOpen = true;
      this.lsModal.logsFor = q;
      this.lsModal.logs = [];
      try{
        const { data } = await api.get(`/api/thoivu/quyet-toan/${q.id}/history`);
        const logs = data?.data || [];
        if (logs?.length){ this.lsModal.logs = logs; return; }
      }catch(e){ /* ignore */ }

      // fallback: dựng meta
      const meta = [];
      if (q.createdAt) meta.push({ at:q.createdAt, actor:q.createdBy, actorName:q.createdByName, action:"CREATE", note:q.ghiChu });
      if (q.canceledAt) meta.push({ at:q.canceledAt, actor:q.canceledBy, actorName:q.canceledByName, action:"CANCEL", note:q.cancelReason });
      this.lsModal.logs = meta;
    },
    async cancelQuyetToan(q){
      const { value: reason } = await Swal.fire({
        title: `Hủy quyết toán #${q.id}?`,
        input: 'text',
        inputLabel: 'Lý do',
        inputPlaceholder: 'Nhập lý do hủy…',
        showCancelButton: true,
        confirmButtonText: 'Hủy quyết toán',
        cancelButtonText: 'Đóng'
      });
      if (reason === undefined) return;
      try{
        await api.post(`/api/thoivu/quyet-toan/${q.id}/cancel`, { lyDo: (reason||"Hủy quyết toán nhầm") });
        // làm mới lịch sử
        await this.openLichSu(this.lsModal.row);

        // mở khóa các ngày thuộc khoảng q.from..q.to
        const row = this.matrix?.rows?.find(r=>r.ldId===this.lsModal.row.ldId);
        if (row){
          const [y,m] = this.filter.month.split("-").map(Number);
          const s = new Date(`${q.from}T00:00:00`), e = new Date(`${q.to}T23:59:59`);
          for (let d=1; d<=this.matrix.daysInMonth; d++){
            const cd = new Date(y,m-1,d);
            if (cd>=s && cd<=e){
              const cell = row.daily.find(c=>c.day===d);
              if (cell && cell.qtId===q.id){ cell.locked=false; cell.qtId=null; }
            }
          }
        }

        this.toastOk("Đã hủy quyết toán");
      }catch(e){
        console.error(e);
        this.alertUser(e?.response?.data?.message || "Hủy quyết toán lỗi", "error");
      }
    },

    // ===== Xuất Excel (include / exclude) =====
    async exportExcel(mode /* 'include' | 'exclude' */){
      if (!this.matrix) return;
      const rows = this.getExportRows();
      if (!rows?.length) return;

      const [y,m] = this.filter.month.split("-").map(Number);
      const dim = this.matrix.daysInMonth;
      const from = `${y}-${String(m).padStart(2,'0')}-01`;
      const to = `${y}-${String(m).padStart(2,'0')}-${String(dim).padStart(2,'0')}`;

      const wb = XLSX.utils.book_new();

      if (mode === 'include'){
        // tính tiền nguyên tháng (bao gồm cả ngày locked)
        const totals = {};
        const batch=6;
        for (let i=0;i<rows.length;i+=batch){
          await Promise.all(rows.slice(i,i+batch).map(async r=>{
            try{
              const {data} = await api.get(`/api/thoivu/cham-cong/tinh-luong/${r.ldId}`, { params:{from,to} });
              totals[r.ldId] = data?.data || null;
            }catch{ totals[r.ldId] = null; }
          }));
        }
        const ws = this.buildSheet3Buoi(dim, rows, totals, `Thoivu_${this.filter.month}_INCLUDE`, {
          highlightLocked: false,
          excludeLockedInTotals: false
        });
        XLSX.utils.book_append_sheet(wb, ws, `Include_${this.filter.month}`);
      }else{
        // loại bỏ các ngày locked: cộng chỉ trên dải unlock
        const totals = await this.computeTotalsExcludeQT(rows);
        const ws = this.buildSheet3Buoi(dim, rows, totals, `Thoivu_${this.filter.month}_EXCLUDE`, {
          highlightLocked: true,
          excludeLockedInTotals: true
        });
        XLSX.utils.book_append_sheet(wb, ws, `Exclude_${this.filter.month}`);
      }

      XLSX.writeFile(wb, `ChamCong_Thoivu_${this.filter.month}_${mode}.xlsx`);
      this.toastOk("Đã xuất Excel");
    },

    async computeTotalsExcludeQT(rows){
      // Ý tưởng: chia tháng thành các đoạn liên tiếp KHÔNG locked cho từng LĐ -> gọi /tinh-luong theo từng đoạn -> cộng dồn
      const [y,m] = this.filter.month.split("-").map(Number);
      const dim = this.matrix.daysInMonth;
      const result = {};

      for (const r of rows){
        const segments = this.buildUnlockedSegments(r, y, m, dim); // [{from,to}, ...]
        // nếu không có đoạn unlock => 0
        if (segments.length===0){
          result[r.ldId] = { tienHanhChinh:0, tienChuNhat:0, tienTangCa:0, tienTangCaCN:0, tongTien:0 };
          continue;
        }

        // gọi tuần tự để tránh nổ rate limit (số đoạn thường ít)
        let acc = { tienHanhChinh:0, tienChuNhat:0, tienTangCa:0, tienTangCaCN:0, tongTien:0 };
        for (const seg of segments){
          try{
            const { data } = await api.get(`/api/thoivu/cham-cong/tinh-luong/${r.ldId}`, { params:{ from: seg.from, to: seg.to }});
            const v = data?.data || {};
            acc.tienHanhChinh += Number(v.tienHanhChinh||0);
            acc.tienChuNhat   += Number(v.tienChuNhat||0);
            acc.tienTangCa    += Number(v.tienTangCa||0);
            acc.tienTangCaCN  += Number(v.tienTangCaCN||0);
            acc.tongTien      += Number(v.tongTien||0);
          }catch(e){
            // bỏ qua đoạn lỗi, vẫn cộng các đoạn khác
          }
        }
        result[r.ldId] = acc;
      }
      return result;
    },

    buildUnlockedSegments(row, y, m, dim){
      // quét từ 1..dim, gom dải ngày mà cell.locked === false
      const segs = [];
      let runStart = null;

      for (let d=1; d<=dim; d++){
        const cell = row.daily.find(c=>c.day===d);
        const unlocked = !cell?.locked;
        if (unlocked){
          if (runStart===null) runStart = d;
        }else{
          if (runStart!==null){
            segs.push({ from: `${y}-${String(m).padStart(2,'0')}-${String(runStart).padStart(2,'0')}`,
                        to:   `${y}-${String(m).padStart(2,'0')}-${String(d-1).padStart(2,'0')}` });
            runStart = null;
          }
        }
      }
      if (runStart!==null){
        segs.push({ from: `${y}-${String(m).padStart(2,'0')}-${String(runStart).padStart(2,'0')}`,
                    to:   `${y}-${String(m).padStart(2,'0')}-${String(dim).padStart(2,'0')}` });
      }
      return segs;
    },

    // ===== Build sheet (tô màu locked + loại khỏi tổng khi exclude) =====
    buildSheet3Buoi(days, rows, totals, titleKey, opts = { highlightLocked:false, excludeLockedInTotals:false }){
      const [y,m] = this.filter.month.split("-").map(Number);
      const COL_STT=0, COL_NAME=1, COL_SHIFT=2, COL_DAY_START=3;
      const COL_TOTAL = COL_DAY_START+days;
      const COL_OT    = COL_TOTAL+1;
      const COL_SUM_HC= COL_OT+1, COL_SUM_CN= COL_OT+2, COL_SUM_TC= COL_OT+3, COL_SUM_TCCN= COL_OT+4, COL_SUM_TONG= COL_OT+5;
      const LAST_COL  = COL_SUM_TONG;

      const company="CÔNG TY TNHH XNK THÉP & THIẾT BỊ CÔNG NGHIỆP MINH TIẾN";
      const title=`BẢNG CHẤM CÔNG THỜI VỤ (3 BUỔI) — ${titleKey || ''}`;

      const aoa=[]; aoa.push([company]); aoa.push([title]);

      const h1=[]; h1[COL_STT]="STT"; h1[COL_NAME]="HỌ VÀ TÊN"; h1[COL_SHIFT]="Buổi";
      h1[COL_DAY_START]="Ngày"; for(let c=COL_DAY_START+1;c<=COL_DAY_START+days-1;c++) h1[c]=null;
      h1[COL_TOTAL]="Tổng công"; h1[COL_OT]="TC (giờ)";
      h1[COL_SUM_HC]="Tiền HC"; h1[COL_SUM_CN]="Tiền CN"; h1[COL_SUM_TC]="Tiền TC"; h1[COL_SUM_TCCN]="Tiền TC CN"; h1[COL_SUM_TONG]="TỔNG";
      aoa.push(h1);

      const h2=[]; h2[COL_STT]=null; h2[COL_NAME]=null; h2[COL_SHIFT]=null;
      for(let d=1; d<=days; d++) h2[COL_DAY_START+d-1]=d;
      h2[COL_TOTAL]=null; h2[COL_OT]=null; h2[COL_SUM_HC]=null; h2[COL_SUM_CN]=null; h2[COL_SUM_TC]=null; h2[COL_SUM_TCCN]=null; h2[COL_SUM_TONG]=null;
      aoa.push(h2);

      const h3=[]; h3[COL_STT]=null; h3[COL_NAME]=null; h3[COL_SHIFT]=null;
      const dow=["CN","T2","T3","T4","T5","T6","T7"];
      for(let d=1; d<=days; d++){ const dt=new Date(y,m-1,d); h3[COL_DAY_START+d-1]=dow[dt.getDay()]; }
      h3[COL_TOTAL]=null; h3[COL_OT]=null; h3[COL_SUM_HC]=null; h3[COL_SUM_CN]=null; h3[COL_SUM_TC]=null; h3[COL_SUM_TCCN]=null; h3[COL_SUM_TONG]=null;
      aoa.push(h3);

      let stt=1;
      (rows||[]).forEach(r=>{
        const lineS=[], lineC=[], lineTC=[];
        lineS[COL_STT]=stt; lineC[COL_STT]=null; lineTC[COL_STT]=null;
        lineS[COL_NAME]=r.hoTen; lineC[COL_NAME]=null; lineTC[COL_NAME]=null;
        lineS[COL_SHIFT]="Sáng"; lineC[COL_SHIFT]="Chiều"; lineTC[COL_SHIFT]="TC (h)";

        (r.daily||[]).forEach(cell=>{
          const col=COL_DAY_START+(cell.day-1);
          lineS[col] = cell.sang ? 0.5 : 0;
          lineC[col] = cell.chieu ? 0.5 : 0;
          lineTC[col]= this.dToNumber((cell.otThuong10||0)+(cell.otCN10||0));
        });

        // Tổng: khi excludeLockedInTotals=true thì bỏ ngày locked
        const totalCong = Number(((r.daily||[]).reduce((s,c)=>{
          const add = (c.sang?0.5:0) + (c.chieu?0.5:0);
          return s + ((opts.excludeLockedInTotals && c.locked) ? 0 : add);
        }, 0)).toFixed(2));

        const totalOT   = this.dToNumber((r.daily||[]).reduce((s,c)=>{
          const add10 = (c.otThuong10||0)+(c.otCN10||0);
          return this.dAdd(s, (opts.excludeLockedInTotals && c.locked) ? 0 : add10);
        }, 0));

        lineS[COL_TOTAL]=totalCong; lineC[COL_TOTAL]=null; lineTC[COL_TOTAL]=null;
        lineS[COL_OT]=totalOT;      lineC[COL_OT]=null;    lineTC[COL_OT]=null;

        const tt = totals[r.ldId] || {};
        lineS[COL_SUM_HC]   = Number((tt?.tienHanhChinh ?? 0));
        lineS[COL_SUM_CN]   = Number((tt?.tienChuNhat   ?? 0));
        lineS[COL_SUM_TC]   = Number((tt?.tienTangCa    ?? 0));
        lineS[COL_SUM_TCCN] = Number((tt?.tienTangCaCN  ?? 0));
        lineS[COL_SUM_TONG] = Number((tt?.tongTien      ?? 0));

        aoa.push(lineS); aoa.push(lineC); aoa.push(lineTC); stt++;
      });

      const ws = XLSX.utils.aoa_to_sheet(aoa);

      // merges
      ws["!merges"]=ws["!merges"]||[];
      ws["!merges"].push({s:{r:0,c:0}, e:{r:0,c:LAST_COL}});
      ws["!merges"].push({s:{r:1,c:0}, e:{r:1,c:LAST_COL}});
      ws["!merges"].push({s:{r:2,c:COL_STT}, e:{r:4,c:COL_STT}});
      ws["!merges"].push({s:{r:2,c:COL_NAME}, e:{r:4,c:COL_NAME}});
      ws["!merges"].push({s:{r:2,c:COL_SHIFT}, e:{r:4,c:COL_SHIFT}});
      ws["!merges"].push({s:{r:2,c:COL_TOTAL}, e:{r:4,c:COL_TOTAL}});
      ws["!merges"].push({s:{r:2,c:COL_OT},    e:{r:4,c:COL_OT}});
      ws["!merges"].push({s:{r:2,c:COL_SUM_HC},   e:{r:4,c:COL_SUM_HC}});
      ws["!merges"].push({s:{r:2,c:COL_SUM_CN},   e:{r:4,c:COL_SUM_CN}});
      ws["!merges"].push({s:{r:2,c:COL_SUM_TC},   e:{r:4,c:COL_SUM_TC}});
      ws["!merges"].push({s:{r:2,c:COL_SUM_TCCN}, e:{r:4,c:COL_SUM_TCCN}});
      ws["!merges"].push({s:{r:2,c:COL_SUM_TONG}, e:{r:4,c:COL_SUM_TONG}});
      ws["!merges"].push({s:{r:2,c:COL_DAY_START}, e:{r:2,c:COL_DAY_START+days-1}});

      // merge 3 dòng/NV
      let bodyRow=5;
      (rows||[]).forEach(()=> {
        ws["!merges"].push({s:{r:bodyRow,c:COL_STT},   e:{r:bodyRow+2,c:COL_STT}});
        ws["!merges"].push({s:{r:bodyRow,c:COL_NAME},  e:{r:bodyRow+2,c:COL_NAME}});
        ws["!merges"].push({s:{r:bodyRow,c:COL_TOTAL}, e:{r:bodyRow+2,c:COL_TOTAL}});
        ws["!merges"].push({s:{r:bodyRow,c:COL_OT},    e:{r:bodyRow+2,c:COL_OT}});
        ws["!merges"].push({s:{r:bodyRow,c:COL_SUM_HC},   e:{r:bodyRow+2,c:COL_SUM_HC}});
        ws["!merges"].push({s:{r:bodyRow,c:COL_SUM_CN},   e:{r:bodyRow+2,c:COL_SUM_CN}});
        ws["!merges"].push({s:{r:bodyRow,c:COL_SUM_TC},   e:{r:bodyRow+2,c:COL_SUM_TC}});
        ws["!merges"].push({s:{r:bodyRow,c:COL_SUM_TCCN}, e:{r:bodyRow+2,c:COL_SUM_TCCN}});
        ws["!merges"].push({s:{r:bodyRow,c:COL_SUM_TONG}, e:{r:bodyRow+2,c:COL_SUM_TONG}});
        bodyRow+=3;
      });

      // widths & style helpers
      ws["!cols"]=[]; ws["!cols"][COL_STT]={wch:5}; ws["!cols"][COL_NAME]={wch:28}; ws["!cols"][COL_SHIFT]={wch:8};
      for(let c=COL_DAY_START;c<COL_DAY_START+days;c++) ws["!cols"][c]={wch:5};
      ws["!cols"][COL_TOTAL]={wch:10}; ws["!cols"][COL_OT]={wch:10};
      ws["!cols"][COL_SUM_HC]={wch:12}; ws["!cols"][COL_SUM_CN]={wch:12}; ws["!cols"][COL_SUM_TC]={wch:12}; ws["!cols"][COL_SUM_TCCN]={wch:12}; ws["!cols"][COL_SUM_TONG]={wch:12};
      ws["!pageSetup"]={orientation:"landscape",fitToWidth:1,fitToHeight:0};

      const borderAll={top:{style:"thin",color:{rgb:"000"}},left:{style:"thin",color:{rgb:"000"}},bottom:{style:"thin",color:{rgb:"000"}},right:{style:"thin",color:{rgb:"000"}}};
      const center={horizontal:"center",vertical:"center"};
      const setS=(r,c,s)=>{ const addr=XLSX.utils.encode_cell({r,c}); if(!ws[addr]) ws[addr]={t:'s',v:''}; ws[addr].s={...(ws[addr].s||{}),...s}; };
      const styleRange=(r1,c1,r2,c2,s)=>{ for(let r=r1;r<=r2;r++){ for(let c=c1;c<=c2;c++){ setS(r,c,s); } } };

      styleRange(0,0,0,LAST_COL,{font:{bold:true,sz:11},alignment:center});
      styleRange(1,0,1,LAST_COL,{font:{bold:true,sz:14},alignment:center});
      styleRange(2,0,4,LAST_COL,{font:{bold:true},alignment:center,border:borderAll});

      const startBody=5;
      const endRow= startBody + (rows?.length||0)*3 - 1;
      if(endRow>=startBody){
        styleRange(startBody, COL_STT, endRow, COL_STT, {alignment:center,border:borderAll});
        styleRange(startBody, COL_SHIFT, endRow, COL_SHIFT, {alignment:center,border:borderAll});
        styleRange(startBody, COL_NAME, endRow, COL_NAME, {alignment:{horizontal:"left",vertical:"center"},border:borderAll});
        styleRange(startBody, COL_DAY_START, endRow, COL_DAY_START+days-1, {alignment:center,border:borderAll});
        styleRange(startBody, COL_TOTAL, endRow, COL_TOTAL, {alignment:center,border:borderAll,numFmt:"0.00"});
        styleRange(startBody, COL_OT, endRow, COL_OT, {alignment:center,border:borderAll,numFmt:"0.0"});
        styleRange(startBody, COL_SUM_HC, endRow, COL_SUM_TONG, {alignment:{horizontal:"right",vertical:"center"},border:borderAll,numFmt:"#,##0"});
      }

      // CN tô nền nhẹ (giữ như cũ)
      for(let d=1; d<=days; d++){ const dt=new Date(y,m-1,d); if(dt.getDay()===0){ const col=COL_DAY_START+(d-1); styleRange(2,col,endRow,col,{fill:{fgColor:{rgb:"FFF8F0"}}}); } }

      // tô màu các ô locked nếu highlightLocked
      if (opts.highlightLocked){
        const lockedStyle={ fill:{fgColor:{rgb:"FFF0F0"}}, font:{italic:true,color:{rgb:"BB0000"}} };
        let rowCursor = startBody;
        (rows||[]).forEach(r=>{
          (r.daily||[]).forEach(cell=>{
            if (!cell.locked) return;
            const col = COL_DAY_START+(cell.day-1);
            setS(rowCursor,   col, lockedStyle); // Sáng
            setS(rowCursor+1, col, lockedStyle); // Chiều
            setS(rowCursor+2, col, lockedStyle); // TC
          });
          rowCursor += 3;
        });

        const noteRow = (endRow>=startBody ? endRow+2 : startBody+2);
        ws[XLSX.utils.encode_cell({r:noteRow, c:COL_NAME})] = { t:'s', v:'* Ô tô màu: đã QUYẾT TOÁN và đã LOẠI khỏi Tổng công, TC (giờ) và các cột Tiền.' };
        setS(noteRow, COL_NAME, { font:{italic:true,color:{rgb:"BB0000"}} });
      }

      return ws;
    },

    // ===== Responsive / UX =====
    onResize(){ this.isMobile = window.matchMedia("(max-width: 768px)").matches; },
    onTableScroll(){
      const el = this.$refs.tableWrap;
      if (!el) return;
      const tol = 4;
      this.scrollMeta.showLeft  = el.scrollLeft > tol;
      this.scrollMeta.showRight = (el.scrollWidth - el.clientWidth - el.scrollLeft) > tol;
    },
    fmtDT(dt){ return dt ? new Date(dt).toLocaleString("vi-VN",{hour12:false}) : "—"; },
    formatDateHuman(dt){ const d=new Date(dt); return d.toLocaleDateString("vi-VN",{weekday:"short",day:"2-digit",month:"2-digit",year:"numeric"}); },
    toastOk(msg){ if(this.$toast?.success) this.$toast.success(msg); else alert(msg); },
    alertUser(msg,type="info"){ if(Swal?.fire) Swal.fire({icon:type,title:msg}); else alert(msg); }
  }
};
</script>

<style scoped>
/* ===== Header sticky ===== */
.header-sticky{ position: sticky; top: 0; z-index: 5; background: #fff; padding-top: .5rem; }

/* ===== Table widths via CSS variables ===== */
.table-sticky-wrap{ --w-select: 44px; --w-name: 200px; --w-day: 36px; --w-total: 92px; --w-ot: 110px; position: relative; }

/* Shadows to hint horizontal scroll */
.table-scroll-shadow{ position: absolute; top: 0; bottom: 0; width: 20px; z-index: 2; pointer-events: none; }
.table-scroll-shadow.left{ left: 0; background: linear-gradient(to right, rgba(0,0,0,.08), rgba(0,0,0,0)); }
.table-scroll-shadow.right{ right: 0; background: linear-gradient(to left, rgba(0,0,0,.08), rgba(0,0,0,0)); }

/* Scroll container */
.table-scroll-x{ overflow-x: auto; -webkit-overflow-scrolling: touch; background: #fff; }

/* Sticky columns */
.sticky-col{ position: sticky; background: #fff; z-index: 3; }
.col-select{ left: 0; min-width: var(--w-select); width: var(--w-select); }
.col-name{ left: var(--w-select); min-width: 0; width: var(--w-name); z-index: 2; }
.sticky-end{ position: sticky; right: 0; background: #fff; z-index: 3; box-shadow: -1px 0 0 rgba(0,0,0,.05); }
.col-total{ min-width: var(--w-total); }
.col-ot{ min-width: var(--w-ot); }
.col-actions{ min-width: 120px; }

/* Day columns */
.day-col{ min-width: var(--w-day); width: var(--w-day); text-align:center; padding:4px 2px; vertical-align:middle; position: relative; }
.head-day .dow{ font-size:11px; color:#666; line-height:1; }
.head-day .daynum{ font-weight:700; font-size:12px; line-height:1.1; }
.sun-head .dow, .sunday-cell{ color:#c62828 !important; background:#fafafa; }
.day-cell{ cursor:pointer; user-select:none; }
.table .fa{ font-size:12px; }
.lock-mark{ position:absolute; right:2px; bottom:2px; font-size:11px; opacity: .8; }

/* 3 buổi: icon mode */
.triple-slot{ display:flex; flex-direction:column; align-items:center; justify-content:center; width:100%; height:100%; }
.triple-line{ display:flex; align-items:center; justify-content:center; height:16px; gap:4px; }
.triple-line .label{ font-size:10px; color:#777; width:14px; text-align:right; }
.badge-ot-on{ background:#e3f2fd; color:#0d47a1; border:1px solid #d6eaf8; }

/* Numeric mode */
.triple-numeric{ display:flex; flex-direction:column; align-items:stretch; }
.cong-box{ display:flex; align-items:center; justify-content:center; width:100%; height:20px; border-radius:6px; font-weight:700; font-size:11px; border:1px solid #eee; }
.cong-zero{ color:#999; background:#f6f7f8; }
.cong-mid{ color:#0d47a1; background:#e3f2fd; border-color:#d6eaf8; }
.ot-box{ display:flex; align-items:center; justify-content:center; width:100%; height:20px; border-radius:6px; font-weight:700; font-size:11px; border:1px dashed #cfd8dc; color:#37474f; background:#fafcfe; }

/* Name */
.name-ellipsis{ max-width: 160px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }

/* Modals */
.modal{ background: rgba(0,0,0,.35); }
.modal.custom-modal .modal-content{ max-height: calc(100vh - 1rem); display:flex; flex-direction:column; }
.modal.custom-modal .modal-body{ overflow-y:auto; }

/* Mobile fullscreen modal */
.modal-fullscreen{ max-width: none !important; width: 100%; height: 100%; margin: 0; }
.modal-fullscreen .modal-content{ height: 100%; border-radius: 0; }

/* KPIs */
.mini-kpi{ border:1px solid #eee; border-radius:10px; padding:10px; margin-bottom:8px; background:#fff; }
.kpi-label{ font-size:12px; color:#666; }
.kpi-value{ font-weight:700; font-size:18px; line-height:1.1; }

/* Mobile FAB */
.mobile-fab{ position: fixed; left: 8px; right: 8px; bottom: 10px; z-index: 6; display: flex; align-items: center; justify-content: center; }
.mobile-fab .btn{ min-width: 36px; }

/* Mobile tweaks */
@media (max-width: 768px){
  .thoivu-wrapper{ font-size: 13px; }
  .head-day .dow{ font-size:10px; }
  .head-day .daynum{ font-size:11px; }
  .name-ellipsis{ max-width: 120px; }

  .table-sticky-wrap{
    --w-name: 160px;
    --w-day: 34px;
  }

  .header-sticky{ padding-bottom: .5rem; }
  .col-actions{ min-width: 100px; }
  .lock-mark{ right:1px; bottom:1px; }
  .triple-line{ height: 15px; }
}

.head-cell {
    display: flex
;
    flex-direction: column;
}
</style>
